import classNames from "components/ui/classNames";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";

interface IBrazilianCompanyMajorityShareholdersProps {
  majorityShareholders: IBrazilianCompanyIssuerTopLevelFragment["majorityShareholders"];
}

function BrazilianCompanyMajorityShareholders({ majorityShareholders }: IBrazilianCompanyMajorityShareholdersProps) {
  const hasShareholderWithPreferredStock = majorityShareholders.some((shareholder) => {
    return shareholder.percentageOfTotalSharesOfPreferredStock > 0;
  });

  return (
    <div>
      <ul className="divide-y divide-slate-100">
        {majorityShareholders.map((shareholder) => {
          return (
            <li key={shareholder.name} className="space-y-2 py-4 first:pt-0 last:pb-0">
              <div className="max-w-xs truncate xl:max-w-md">
                <span title={shareholder.name} className="text-base font-medium text-gray-500 xl:text-sm">
                  {shareholder.name}
                </span>
              </div>

              <div className="flex items-center space-x-4">
                <span
                  className="text-sm font-bold"
                  style={{
                    color:
                      shareholder.percentageOfTotalSharesOfCommonStock >= 50 ? palette.scienceBlue : palette.copper,
                  }}
                >
                  {shareholder.percentageOfTotalSharesOfCommonStock.toFixed(0).replace(".", ",")}% ON
                </span>

                {hasShareholderWithPreferredStock && (
                  <div>
                    <span
                      className="text-sm font-bold"
                      style={{
                        color:
                          shareholder.percentageOfTotalSharesOfPreferredStock >= 50
                            ? palette.scienceBlue
                            : palette.copper,
                      }}
                    >
                      {shareholder.percentageOfTotalSharesOfPreferredStock
                        .toFixed(
                          shareholder.percentageOfTotalSharesOfPreferredStock > 0 &&
                            shareholder.percentageOfTotalSharesOfPreferredStock < 1
                            ? 2
                            : 0,
                        )
                        .replace(".", ",")}
                      % PN
                    </span>
                  </div>
                )}

                {shareholder.isGovernmentOrGovernmentRelated && (
                  <span
                    key={shareholder.name}
                    className={classNames(
                      "ml-auto rounded-xl border border-red-100 bg-red-50",
                      "px-3 py-0.5 text-center text-xs font-bold uppercase text-red-600",
                    )}
                  >
                    Governo
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default BrazilianCompanyMajorityShareholders;
